import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '@services/auth.service';
import { isPublicEndpoint } from '@core/constants/auth-endpoints';
import { SKIP_AUTH_TOKEN } from '../../landing/services/landing-news.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getAccessToken();

  const skipAuth = req.context.get(SKIP_AUTH_TOKEN);
  const isRefreshEndpoint = req.url.includes('/api/auth/refresh');
  const shouldAddToken = token && !skipAuth && (isRefreshEndpoint || !isPublicEndpoint(req.url));

  if (shouldAddToken) {
    const authReq = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });

    return next(authReq);
  }

  return next(req);
};
